import { element } from "prop-types";

window.CustomFields = {};

let togglePossibleValues = (selectedFieldType) => {
  if (selectedFieldType.includes('select', 'multiselect')) {
    $('.custom_field_values').removeClass('hidden');
  } else {
    $('.custom_field_values').addClass('hidden');
  }
};

let toggleDefaultValues = (selectedFieldType) => {
  let defaultValueContainers = $('.custom_field_default_values');
  let defaultValueInputs = $('.custom_field_default_values textarea');

  switch (selectedFieldType) {
    case 'editor':
      defaultValueInputs.each((_index, input) => {
        let editor = $(input).data('editor');
        if (!_.isObject(editor)) {
          Editor.initTextEditor(input, { simplifiedButtons: true }).then((initialized) => {
            if ($('#custom_field_type option:selected').val() === 'editor') return

            initialized.destruct();
            $(input).data('editor', null);
          });
        }
      });
      defaultValueContainers.removeClass('hidden');
      break;
    case 'text':
    case 'multiline':
      defaultValueInputs.each((_index, input) => {
        let editor = $(input).data('editor');
        if (_.isObject(editor)) {
          editor.destruct();
          $(input).data('editor', null);
        }
      });
      defaultValueContainers.removeClass('hidden');
      break;
    default:
      defaultValueContainers.addClass('hidden');
  }
};

CustomFields.initSelectValues = function () {
  $('#custom_field_type').on('change', function () {
    let selected = $('option:selected', this).val();

    togglePossibleValues(selected);
    toggleDefaultValues(selected);
  });

  $('#custom_field_type').trigger('change');
};
